import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import styles from "../../styles/admanager/UserAdManagerEarnings.module.scss";
import { getAccountSubscription } from "../../selectors/currentAccountSelector";
import { fetchTotalEarningsToBePaid } from "../../api/monetization";
import { redirectToPlans } from "../../utils/routes";
import { BB2RevShare, BB3RevShare, BB4RevShare } from "../../textContent/planRevShare";
import selectUserTokens from "../../selectors/selectUserTokens";
import { formatCentsToDollars } from "../../actions/monetization";
import isLoggingInFromClient from "../../selectors/isLoggingInFromClient";

import { openNewWindow } from "../../utils/helperUtils";
import { storeSSOTokens } from "../../api/auth";

import UserEarningMonthToDate  from './UserEarningMonthToDate';
import Log from "../../utils/Log";

export default function UserTotalEarnings({ props }) {
  const clientLoginState = useSelector(isLoggingInFromClient);
  const authTokens = useSelector(selectUserTokens);
  const subscription = useSelector(getAccountSubscription);
  const [userShareTotal, setUserShareTotal] = useState("$-.--");

  useEffect(() => {
    async function fetchTotalEarnings() {
      try {
        const fetchedTotalEarnings = await fetchTotalEarningsToBePaid(
          authTokens?.accessToken
        );
        const formattedEarnings = formatCentsToDollars(
          fetchedTotalEarnings.payload.earnings
            ? fetchedTotalEarnings.payload.earnings.net
            : 0
        );
        setUserShareTotal(formattedEarnings);
      }
      catch (e) {
        Log.error("Error while retrieving earnings report " + e.message)
        Log.error(e.stack)
        setUserShareTotal("(error loading)")
      }
    }
    fetchTotalEarnings();
  }, [authTokens]);

  // TODO BB4 Release wait what's going on here. is it out of date? Also the numbers in the actual BBXRevShare items look wrong to me?
  function DisplayRoyaltyTerms() {
    return subscription.map((sub, i) => {
      //const revShare = sub.product === "BB3" ? BB3RevShare : BB2RevShare;
      // Ad Manager MVP releasing with only BB3
      //if (sub.product === "BB3") {
      let revShare = null
      if(sub.product === "BB4") {
        revShare = BB4RevShare
      }
      else if(sub.product === "BB3") {
        revShare = BB3RevShare
      }
      else if(sub.product === "BB2") {
        revShare = BB2RevShare
      }
      else {
        console.log("no revshare info for product ", sub.product)
      }
      if(revShare) {
        return (
          <div className={styles.terms} key={i}>
            <div className={styles.upgradeWrapper}>
              {checkRoyaltyAvailable(
                sub.subscriptionTier,
                revShare,
                sub.product
              )}
            </div>
          </div>
        );
      } else {
        return undefined;
      }
    }
    );
  }

  async function fetchSSOToken() {
    const { accessToken, refreshToken } = authTokens;

    const token = await storeSSOTokens(
      process.env.REACT_APP_COGNITO_APP_CLIENT_ID,
      "",
      accessToken,
      refreshToken
    );
    return token;
  }

  async function handleUpgradeClick(props, productType) {
    const ssoToken = await fetchSSOToken();
    if (clientLoginState) {
      openNewWindow(
        `${
          process.env.REACT_APP_DOMAIN_URL
        }/sso_plans?token=${ssoToken}&view=${productType.toLowerCase()}`,
        false
      );
    } else {
      redirectToPlans(props);
    }
  }

  function checkRoyaltyAvailable(subscriptionTier, product) {
    let nextSubscription;
    if (subscriptionTier === "Free") {
      nextSubscription = "Plus";
    } else if (subscriptionTier === "Plus") {
      nextSubscription = "Pro";
    } else {
      return;
    }

    return (
      <div className={styles.upgradeBox}>
        <div>Earn more Revenue!</div>
        <button
          onClick={() => handleUpgradeClick(props, product)}
          className={styles.upgradeBtn}
        >
          Upgrade To {nextSubscription}
        </button>
      </div>
    );
  }

  function getLastMonth() {
    const first = new Date(); // current date
    first.setDate(0);
    first.setDate(1);
    let firstMonth = first.toLocaleString("en-US", { month: "short" });
    let firstDay = first.toLocaleString("en-US", { day: "numeric" });

    const last = new Date(); // current date
    last.setDate(1);
    last.setHours(-1);
    let lastMonth = last.toLocaleString("en-US", { month: "short" });
    let lastDay = last.toLocaleString("en-US", { day: "numeric" });

    return `${firstMonth} ${firstDay} through ${lastMonth} ${lastDay}`;
  }

  const openUrl = (e) => {
    const url = "https://www.buildbox.com/rev-share-details/";
    e.preventDefault();
    if (clientLoginState) {
      openNewWindow(url, false);
    } else {
      window.open(url, "_blank");
    }
  };

  return (
    <div className={styles.totalEarningsWrapper}>
      <div className={styles.totalEarningsBlurb}>Every 15th of each month</div>
      <div className={styles.safeSecureBlurb}>
        Your transactions are safe and secure.{" "}
        {/* TODO: make a button component that is styled as a link */}
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a href="" onClick={(e) => openUrl(e)}>
          Learn More
        </a>
      </div>
      <div className={styles.totalEarningsBoxWrapper}>
       <div>
          {/* <h3>This Month Earnings</h3> */}
          <UserEarningMonthToDate/>
        </div>
        <div className={styles.paymentRange}>
          <b>{getLastMonth()}</b> net deposit
        </div>
         
        <div className={styles.totalEarningsBoxOrange}>
          <div className={styles.totalEarningAmount}>{userShareTotal}</div>
        </div>
        <div className={styles.royaltyTerms}>{DisplayRoyaltyTerms()}</div>
      </div>
    </div>
  );
}
